import styled from "styled-components";

export const Wrapper = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  maxWidth: 900,
  margin: "40px auto",
  padding: "0 16px",
  color: theme.palette.text?.primary,

  [theme.down("md")]: {
    maxWidth: 700,
  },

  [theme.down("sm")]: {
    maxWidth: "100%",
  },
}));

export const Header = styled("div")(() => ({
  marginBottom: 8,
}));

export const Title = styled("h1")(({ theme }) => ({
  fontSize: 24,
  fontWeight: 700,
  textAlign: "center",
  textTransform: "uppercase",
  lineHeight: "32px",
  color: theme.palette.text?.primary,
}));

export const Subtitle = styled("p")(({ theme }) => ({
  marginTop: 8,
  fontSize: 16,
  lineHeight: "24px",
  textAlign: "center",
  color: theme.palette.text?.secondary,
}));

export const MetaList = styled("div")(({ theme }) => ({
  marginTop: 20,
  padding: "16px 0",
  borderTop: `1px solid ${theme.palette.text?.mutedLighter}`,
  borderBottom: `1px solid ${theme.palette.text?.mutedLighter}`,
}));

export const MetaItem = styled("p")(({ theme }) => ({
  fontSize: 14,
  lineHeight: "22px",
  color: theme.palette.text?.secondary,
}));

export const MetaLabel = styled("span")(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text?.primary,
}));

export const Section = styled("div")(() => ({
  marginTop: 32,
}));

export const SectionTitle = styled("h2")(({ theme }) => ({
  marginBottom: 12,
  fontSize: 17,
  fontWeight: 700,
  lineHeight: "24px",
  color: theme.palette.text?.primary,
}));

export const Text = styled("p")(({ theme }) => ({
  marginBottom: 10,
  fontSize: 15,
  lineHeight: "24px",
  color: theme.palette.text?.secondary,
}));

export const List = styled("ul")(() => ({
  margin: "0 0 10px",
  paddingLeft: 24,
}));

export const ListItem = styled("li")(({ theme }) => ({
  paddingTop: 5,
  fontSize: 15,
  lineHeight: "24px",
  color: theme.palette.text?.secondary,
}));

export const ContactTable = styled("dl")(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "240px 1fr",
  gap: "8px 16px",
  marginTop: 12,
  fontSize: 15,
  lineHeight: "24px",

  [theme.down("sm")]: {
    gridTemplateColumns: "1fr",
    gap: 4,
  },
}));

export const ContactLabel = styled("dt")(({ theme }) => ({
  fontWeight: 600,
  color: theme.palette.text?.primary,
}));

export const ContactValue = styled("dd")(({ theme }) => ({
  margin: 0,
  color: theme.palette.text?.secondary,

  [theme.down("sm")]: {
    marginBottom: 8,
  },
}));
